export const API_PATH_ApiAppPresetPost = '/services/app/presets/apiAppPresetPost';
